<template>
  <div class="d-flex justify-center">
    <Day
      v-for="(date, index) in dates"
      :key="index"
      class="mx-2"
      :date="date"
      :active="$moment(date).valueOf() === $moment(activeDate).valueOf()"
      @slectedDate="selectedDate = $event"
    />
  </div>
</template>

<script>
import Day from '@/components/common/Day'

export default {
  components: { Day },
  props: {
    dates: {
      type: Array,
      required: true
    },
    activeDate: {
      required: true
    }
  },
  data () {
    return {
      selectedDate: null
    }
  },
  watch: {
    selectedDate (date) {
      this.$emit('update:date', date)
    }
  }
}
</script>
